export default "__VITE_ASSET__Dz4o7ykD__"